import { lazy } from 'react';

export const WritingExamPrepDashboardPage = lazy(() => import('./WritingExamPrepDashboardPage'));
